import * as React from 'react';
import { pure } from 'recompose';

import {
  addElementClass,
  hasElementClass,
  removeElementClass,
} from '../../../utils/autoHideStickyHeader';

interface DialogWrapperProps {
  isDialogOpen: boolean;
  initialLock?: boolean;
}

interface DialogWrapperState {
  scrollPosition: number;
}

class DialogWrapper extends React.Component<
  DialogWrapperProps,
  DialogWrapperState
> {
  constructor(props: DialogWrapperProps) {
    super(props);
    this.state = { scrollPosition: 0 };
  }

  componentDidMount() {
    const { initialLock } = this.props;
    if (initialLock && this.props.isDialogOpen) {
      this.disableBodyScroll();
    }
  }

  componentDidUpdate(prevProps: DialogWrapperProps): void {
    if (this.props.isDialogOpen !== prevProps.isDialogOpen) {
      if (this.props.isDialogOpen) {
        this.disableBodyScroll();
      } else {
        this.enableBodyScroll();
      }
    }
  }

  componentWillUnmount() {
    this.enableBodyScroll();
  }

  enableBodyScroll = () => {
    const el = document.body;
    const { scrollPosition } = this.state;
    if (hasElementClass(el, 'dw-body-disable-scroll')) {
      removeElementClass(el, 'dw-body-disable-scroll');
      el.style.removeProperty('top');
      window.scrollTo(0, scrollPosition);
    }
  };

  disableBodyScroll = () => {
    const el = document.body;
    if (!el) {
      console.error('No body element found!');
      return;
    }

    // Preserve the scroll position of the body.
    const scrollPosition = window.scrollY;
    this.setState({ scrollPosition });
    el.style.top = `-${scrollPosition}px`;
    addElementClass(el, 'dw-body-disable-scroll');
  };

  render() {
    return <div>{this.props.children}</div>;
  }
}

export default pure(DialogWrapper);
